import logo from './logo.svg';
import './App.css';

import Home from "./Pages/Home"
import Login from "./Pages/Dasboard/Login/LoginScreen"
import Connectscreen from "./Pages/Dasboard/Login/connectscreen"
import RegisterScreen from "./Pages/Dasboard/Signup/registerScreen"
import ForgetScreen from "./Pages/Dasboard/Signup/forgetScreen"
import UpdateScreen from "./Pages/Dasboard/Signup/updateScreen"
import DashboadScreen from "./Pages/Dasboard/Mainscren"
import NFTS from "./Pages/Dasboard/NFTS"
import Others from './Pages/Others'
import PageNotFound from './Pages/404/error'
import Test from './Pages/test'
import * as ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import PrivacyPolicy from './Pages/PrivacyPolicy';
import Terms from './Pages/Terms';
import Rewards from './Pages/Dasboard/Rewards';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/connect-wallet" element={<Connectscreen />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<RegisterScreen />} />
          <Route path="/forget-password" element={<ForgetScreen />} />
          <Route path="/update-password" element={<UpdateScreen />} />
          <Route path="/dashboard" element={<DashboadScreen />} />
          <Route path="/nfts" element={<NFTS />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/others" element={<Others />} />
          <Route path="/test" element={<Test />} />

          <Route path="*" element={<PageNotFound/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
